// extracted by mini-css-extract-plugin
export default {"addBtn":"AddTopBottomBtn_addBtn__d7KIN"};